var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('router-view'),_c('Privacy',{ref:"vPrivacy"}),_c('GoTop',{ref:"vGoTop"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }